import { Gig } from '@fiverr-private/listing_types';
import { PROMOTED_GIGS, VIDEO_STRIP } from '../constants';

export const findVideoStripGig = (gigs: Gig[]) => gigs?.find((gig: any) => gig.type === VIDEO_STRIP);

export function calcVideoStripPosition(gigs: Gig[], isCarouselExists: boolean) {
    const firstAdIndex = gigs.findIndex(
        (gig, i) =>
            gig.type === VIDEO_STRIP || (i > 0 && gig.type === PROMOTED_GIGS && gigs[i - 1]?.type !== PROMOTED_GIGS)
    );
    if (firstAdIndex <= 0) {
        return -1;
    }
    return isCarouselExists ? firstAdIndex + 4 : firstAdIndex;
}
